import { IPointBase } from "../../../Models/IPoint";

export interface IPolygonQueryParams {
    title: string;
    points: IPointBase[];
};